import { h } from 'preact'

export default () => (
  <svg width='169' height='120' viewBox='0 0 169 120' fill='none' xmlns='http://www.w3.org/2000/svg' class='template-icon'>
    <path d='M0 4C0 1.79086 1.79086 0 4 0H165C167.209 0 169 1.79086 169 4V116C169 118.209 167.209 120 165 120H4C1.79086 120 0 118.209 0 116V4Z' fill='#F0F2F8' />
    <mask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='18' y='23' width='132' height='73'>
      <rect x='18' y='23' width='132' height='73' rx='4' fill='white' />
    </mask>
    <g mask='url(#mask0)'>
      <rect x='18' y='23' width='132' height='73' fill='white' />
      <rect x='71' y='33' width='27' height='27' rx='3' fill='#AB2692' />
      <rect x='46' y='66' width='76' height='8' rx='4' fill='#9599A2' />
      <rect x='59' y='80' width='50' height='6' rx='3' fill='#BFC2C8' />
    </g>
    <rect x='18.5' y='23.5' width='131' height='72' rx='3.5' stroke='#D5D6DA' />
  </svg>
)
